import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block cursor-pointer">
              <h4 className="text-lg font-heading font-bold text-background-50 mb-3">
                {siteConfig.name}
              </h4>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteConfig.description.slice(0, 80)}...
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-sm font-semibold text-background-200 mb-4">快速导航</h5>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h5 className="text-sm font-semibold text-background-200 mb-4">常用资源</h5>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">专家团队</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">合作咨询</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">隐私政策</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h5 className="text-sm font-semibold text-background-200 mb-4">联系我们</h5>
            <div className="space-y-3 text-sm text-background-400">
              <p>邮箱：{siteConfig.email}</p>
              <p>电话：{siteConfig.phone}</p>
              <p>微信：{siteConfig.wechat}</p>
              <div className="flex items-center gap-4 pt-2">
                <a href={siteConfig.socialLinks.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-chat-smile-2-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-vidicon-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {siteConfig.foundingYear} - {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer">京ICP备XXXXXXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}